<template>
  <section class="custom-container my-1" v-if="places.length">
    <h2 class="text-center font-lg font-bold mt-4 mb-2">{{ info.title }}</h2>
    <p class="my-1">{{ info.description }}</p>

    <div
      v-if="isMobile"
      ref="carousel"
      class="store-carousel"
      @mouseenter="pauseAutoSlide"
      @mouseleave="startAutoSlide"
    >
      <div
        class="carousel-track"
        :style="{ transform: `translateX(-${scrollX}px)` }"
      >
        <a
          v-for="(option, index) in places"
          :key="`option-${index}`"
          :href="option.url"
          target="_blank"
          rel="noopener noreferrer"
          :aria-label="`Ir a ${option.name || 'el sitio'}`"
        >
          <img
            class="store-icon"
            :src="option.img"
            :alt="option.alt || 'Imagen representativa'"
            loading="lazy"
            width="120"
            height="120"
          />
        </a>
      </div>
    </div>

    <!-- Vista de escritorio: todos los logos estáticos -->
    <div v-else class="row center gap-4 mt-4">
      <a
        v-for="(option, index) in info.places"
        :key="`option-static-${index}`"
        :href="option.url"
        target="_blank"
        rel="noopener noreferrer"
        :aria-label="`Ir a ${option.name || 'el sitio'}`"
      >
        <img
          class="store-icon"
          :src="option.img"
          :alt="option.alt || 'Imagen representativa'"
          loading="lazy"
          width="120"
          height="120"
        />
      </a>
    </div>
  </section>
</template>

<script>
import { useScreen } from '../../composables/useScreen';

export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  setup () {
    const { isMobile } = useScreen()

    return { isMobile}
  },
  data() {
    return {
      scrollX: 0,
      intervalId: null,
      step: 0,
      places: [],
      trackWidth: 0
    };
  },
  methods: {
    startAutoSlide() {
      if (this.intervalId || !this.$refs.carousel) return;
      
      const carouselWidth = this.$refs.carousel.offsetWidth;
      const track = this.$refs.carousel.querySelector('.carousel-track');
      if (!track) return;
      
      this.trackWidth = track.scrollWidth;
      
      this.intervalId = setInterval(() => {
        this.scrollX += carouselWidth;
        this.step++;

        if (this.scrollX >= this.trackWidth / 2) {
          this.scrollX = 0;
          this.step = 0;
        }
      }, 3000);
    },
    pauseAutoSlide() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  mounted() {
    // Duplicamos una sola vez para efecto de carrusel infinito
    this.places = [...this.info.places, ...this.info.places];
    
    setTimeout(() => {
      this.startAutoSlide();
    }, 300)
  },
  beforeUnmount() {
    this.pauseAutoSlide();
  }
};
</script>

<style scoped>
.store-carousel {
  overflow-y: hidden;
  overflow-x: auto;
  position: relative;
  width: 100%;
  margin-top: 1rem;
}

.carousel-track {
  display: flex;
  flex-wrap: nowrap;
  transition: transform 0.6s ease-in-out;
}

.store-icon {
  width: 120px;
  height: 120px;
  margin: 0 16px;
  flex-shrink: 0;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.store-icon:hover {
  transform: scale(1.1);
}
</style>
